function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';
import textEllipsis from 'text-ellipsis';
import Button from '../button/Button';
import ListItem from '../listItem/ListItem';
import { TYPES as BUTTON_TYPES } from '../button/constants';
import { ICON_TYPE_PROP_TYPE, ICON_SIZE_PROP_TYPE, COLOR_PROP_TYPE } from '../icon/constants';
import { PAYMENT_TYPE_PROP_TYPE, PAYMENT_SIZE_PROP_TYPE } from '../paymentIcon/constants';
import { TEXT_ITEMS_CHARACTER_LENGTH_MAP } from './constants';
import { VERTICAL_ALIGNMENTS_PROP_TYPE } from '../listItem/constants';

var Content = function Content(_ref) {
  var content = _ref.content,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 'primary' : _ref$level,
      isDisabled = _ref.isDisabled,
      _ref$ellipsis = _ref.ellipsis,
      ellipsis = _ref$ellipsis === void 0 ? true : _ref$ellipsis;

  if (!content) {
    return null;
  }

  var contentClassName = classNames("eds-text-list-item__content-".concat(level), {
    'eds-text-list-item__content--disabled': isDisabled
  });
  var text = content;

  if (ellipsis) {
    text = textEllipsis(content, TEXT_ITEMS_CHARACTER_LENGTH_MAP[level]);
  }

  return React.createElement("div", {
    className: contentClassName
  }, text);
};

var TextListItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextListItem, _React$PureComponent);

  function TextListItem() {
    _classCallCheck(this, TextListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextListItem).apply(this, arguments));
  }

  _createClass(TextListItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isFocusable && this.props.isTentativelySelected) {
        this.itemContent.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          buttonType = _this$props.buttonType,
          children = _this$props.children,
          content = _this$props.content,
          extraContent = _this$props.extraContent,
          iconType = _this$props.iconType,
          iconTypes = _this$props.iconTypes,
          iconSize = _this$props.iconSize,
          iconColor = _this$props.iconColor,
          imageAlt = _this$props.imageAlt,
          imageUrl = _this$props.imageUrl,
          isDisabled = _this$props.isDisabled,
          isSquareImage = _this$props.isSquareImage,
          isSelected = _this$props.isSelected,
          isTentativelySelected = _this$props.isTentativelySelected,
          isFocusable = _this$props.isFocusable,
          onSelect = _this$props.onSelect,
          onItemContentFocus = _this$props.onItemContentFocus,
          path = _this$props.path,
          render = _this$props.render,
          secondaryContent = _this$props.secondaryContent,
          tertiaryContent = _this$props.tertiaryContent,
          verticalAlignment = _this$props.verticalAlignment,
          useProgressIndicator = _this$props.useProgressIndicator;
      var containerClassName = classNames('eds-text-list-item', {
        'eds-text-list-item--selected': isSelected,
        'eds-text-list-item--disabled': isDisabled,
        'eds-text-list-item--tentatively-selected': isTentativelySelected
      });
      var renderContainer = render; // if no render prop is passed, set default container to be Button we all know and love

      if (!renderContainer) {
        var href = isDisabled ? null : path;

        var _getElement = function _getElement(element) {
          _this.itemContent = element;
        };

        renderContainer = function renderContainer(props) {
          return React.createElement(Button, {
            disabled: isDisabled,
            href: href,
            style: "none",
            onClick: props.onSelect,
            onFocus: props.onItemContentFocus,
            type: buttonType,
            "data-spec": "text-list-item-button",
            __containerClassName: props.containerClassName,
            ref: _getElement,
            size: "block"
          }, props.children);
        };
      }

      var renderChildren = React.createElement(ListItem, {
        extraContent: extraContent,
        iconType: iconType,
        iconTypes: iconTypes,
        iconSize: iconSize,
        iconColor: iconColor,
        imageUrl: imageUrl,
        imageAlt: imageAlt,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTentativelySelected: isTentativelySelected,
        isFocusable: isFocusable,
        isSquareImage: isSquareImage,
        verticalAlignment: verticalAlignment,
        useProgressIndicator: useProgressIndicator
      }, React.createElement(Content, {
        content: content,
        level: "primary",
        ellipsis: false,
        isDisabled: isDisabled
      }), React.createElement(Content, {
        content: secondaryContent,
        level: "secondary",
        isDisabled: isDisabled
      }), React.createElement(Content, {
        content: tertiaryContent,
        level: "tertiary",
        isDisabled: isDisabled
      }), children);
      return React.createElement("div", {
        className: containerClassName,
        "data-spec": "text-list-item"
      }, renderContainer({
        children: renderChildren,
        containerClassName: 'eds-text-list-item__button',
        onSelect: onSelect,
        onItemContentFocus: onItemContentFocus
      }));
    }
  }]);

  return TextListItem;
}(React.PureComponent);

_defineProperty(TextListItem, "propTypes", {
  /**
   * The type of button subcomponent to be used
   */
  buttonType: PropTypes.oneOf(BUTTON_TYPES),

  /**
   * Any child nodes to be displayed that should not have the content styling
   */
  children: PropTypes.node,

  /**
   * The primary content to be displayed
   */
  content: PropTypes.node,

  /**
   * Generic content for the left side
   */
  extraContent: PropTypes.node,

  /**
   * Icon to include in the list item that when specified will wrap the `children` to include the icon
   */
  iconType: PropTypes.oneOfType([ICON_TYPE_PROP_TYPE, PAYMENT_TYPE_PROP_TYPE]),

  /**
   * Icons to include in the list item that when specified will wrap the `children` to include the icons
   */
  iconTypes: PropTypes.arrayOf(PropTypes.oneOfType([ICON_TYPE_PROP_TYPE, PAYMENT_TYPE_PROP_TYPE])),

  /**
   * Size of included icon
   */
  iconSize: PropTypes.oneOfType([ICON_SIZE_PROP_TYPE, PAYMENT_SIZE_PROP_TYPE]),

  /**
   * Color of included icon
   */
  iconColor: COLOR_PROP_TYPE,

  /**
   * URL of image to be displayed with list item content
   */
  imageUrl: PropTypes.string,

  /**
   * Alt text for image to be displayed with list item content
   */
  imageAlt: EBPropTypes.translation,

  /**
   * Whether or not the item is disabled
   */
  isDisabled: PropTypes.bool,

  /**
   * Optional square shape image - note you must pass in an imageUrl
   * for an image that is either 1:1 or wider than it is tall.
   */
  isSquareImage: PropTypes.bool,

  /**
   * Whether or not the list item is selected
   */
  isSelected: PropTypes.bool,

  /**
   * Whether or not the text list item is tenatively selected.
   * This comes into play on hover or via arrow key press before an
   * actual selection is made
   */
  isTentativelySelected: PropTypes.bool,

  /**
   * Whether or not the text list item should be focusable
   */
  isFocusable: PropTypes.bool,

  /**
   * Callback function invoked when the text list item is selected
   */
  onSelect: PropTypes.func,

  /**
   * Calback function invoked when the text list item content, by default button, receives focus
   */
  onItemContentFocus: PropTypes.func,

  /**
   * Url path for the button (if it's a link)
   */
  path: PropTypes.string,

  /**
   * Bypasses the default Button container and uses whatever your container your render function returns in its place! (neat!)
   * render is passed the styles that are used on other button containers so your container can match. It also provides
   * children so you can render children into your render container.
   *
   * ({children, onSelect, containerClassName}) => {...render children here}
   */
  render: PropTypes.func,

  /**
   * The secondary content to be displayed
   */
  secondaryContent: PropTypes.node,

  /**
   * The tertiary content to be displayed
   */
  tertiaryContent: PropTypes.node,

  /**
   * Vertical alignment of children items
   */
  verticalAlignment: VERTICAL_ALIGNMENTS_PROP_TYPE,

  /**
   * Whether or not the item should use a progress indicator while the image is loading
   */
  useProgressIndicator: PropTypes.bool
});

_defineProperty(TextListItem, "defaultProps", {
  isSelected: false,
  isDisabled: false,
  isTentativelySelected: false,
  isFocusable: true,
  useProgressIndicator: false
});

export { TextListItem as default };